import BasicTheme from '../components/themes/basicTheme';
import MobilePdfReader from '../components/mobile/MobilePdfReader';
import useIsMobile from '../hooks/useIsMobile';
import useBookSeo from '../utils/useBookSeo';
import { useParams, Navigate } from 'react-router-dom';

function BookReader() {
  const { book_id } = useParams();
  const isMobile = useIsMobile();
  useBookSeo(book_id);

  if (!book_id) {
    return <Navigate to="/" replace />;
  }

  if (isMobile) {
    return <MobilePdfReader bookId={book_id} />;
  }

  return (
    <div className="book-reader-container">
      <BasicTheme book_id={book_id} />
    </div>
  );
}

export default BookReader;
